import firebase from 'firebase';

export const querySnapshotToDocuments = <T = { id: string }>(
  qs: firebase.firestore.QuerySnapshot
): Array<T> => {
  return (qs.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  })) as unknown) as Array<T>;
};

export const documentSnapshotToDocument = <T = { id: string }>(
  ds: firebase.firestore.DocumentSnapshot
): T => {

  if(!ds.exists) return null
  
  return ({
    id: ds.id,
    ...ds.data(),
  } as unknown) as T;
};

type FieldsTransformer<T> = {
  [key in keyof T]?: (field: T[key], document: T) => unknown;
};

export const transformFields = <T>(
  docs: Array<T>,
  fieldsTransformer: FieldsTransformer<T>
) => {
  const keys = Object.keys(fieldsTransformer);

  return docs.map(doc => {
    keys.forEach(key => {
      if (doc[key]) {
        doc[key] = fieldsTransformer[key](doc[key], doc);
      } else {
        doc[key] = fieldsTransformer[key](null, doc);
      }
    });

    return doc;
  });
};

const addFieldsToDocument = <T>(
  doc: T,
  fields?: Record<string, () => unknown>
) => {
  const keys = Object.keys(fields);

  keys.forEach(key => {
    if (!doc[key]) {
      doc[key] = fields[key]();
    }
  });

  return doc;
};

const addFieldsToDocumentsArray = <T>(
  docs: Array<T>,
  fields?: Record<string, () => unknown>
) => docs.map(doc => addFieldsToDocument(doc, fields));

export const serializer = {
  querySnapshotToDocuments,
  documentSnapshotToDocument,
  transformFields,
  addFieldsToDocument,
  addFieldsToDocumentsArray,
};
